'use strict';
module.exports = function RemoteImportController(configurationGenerator, storageApi, goldApi) {
	let currentImport = false;
	if (!configurationGenerator || !storageApi || !goldApi)  {
		throw new Error('invalid-args');
	}
	const self = this,
		workflowError = function (reason, fileId) {
			if (fileId) {
				return Promise.reject({reason: reason, fileId: fileId});
			} else {
				return Promise.reject(reason);
			}
		},
		waitForResult = function (exportConfig) {
			let shouldInterrupt = false;
			const isStopped = function () {
					return shouldInterrupt;
				},
				pollForError = exportConfig => {
					return storageApi.poll(exportConfig.signedErrorListUrl, {stoppedSemaphore: isStopped, sleepPeriod: 15000})
					.then(() => Promise.reject('generation-error'));
				},
				pollForSuccess = exportConfig => storageApi.poll(exportConfig.signedOutputListUrl, {stoppedSemaphore: isStopped, sleepPeriod: 2500});

			return Promise.race([pollForSuccess(exportConfig), pollForError(exportConfig)])
				.then(function () {
					shouldInterrupt = true;
				})
				.catch(function (reason) {
					shouldInterrupt = true;
					throw reason;
				});
		};
	self.knownImport = (format) => ['mmap'].includes(format);
	self.startImport = function (format, importContent, options) {
		let localImportConfig = false;
		const notifyListeners = function (notification) {
				if (options && options.notify) {
					options.notify(notification);
				}
			},
			progress = function (progressEvent) {
				notifyListeners('Uploading ' + (progressEvent || ''));
			};


		notifyListeners('Setting up the import');

		return configurationGenerator.generateImportMapConfiguration(format)
			.then(importConfig => localImportConfig = importConfig)
			.then(() => storageApi.save(importContent, localImportConfig, {notify: progress}))
			.then(() => notifyListeners('Processing your import'))
			.then(() => waitForResult(localImportConfig))
			.then(() => {
				currentImport = {
					importId: localImportConfig.s3UploadIdentifier,
					importType: format
				};
			})
			.catch(reason => workflowError(reason, localImportConfig && localImportConfig.s3UploadIdentifier));
	};
	self.finalise = (license, mapName) => {
		if (!license || !mapName) {
			return Promise.reject('invalid-args');
		}
		if (!currentImport) {
			return Promise.reject('invalid-request');
		}
		return goldApi.exec('file/import_map/gold/finalise', {
			license: license,
			importType: currentImport.importType,
			importId: currentImport.importId,
			mapName: mapName})
		.then(fileId => {
			currentImport = false;
			return {id: `_v2/${fileId}`};
		});
	};
};

